import * as React from 'react';

import Trash16 from './Trash16';

export const trash16 = () => <Trash16 />;

export default {
    title: 'Icon|Fill|Trash16',
    component: Trash16,
    parameters: {
        notes: "`import Trash16 from 'box-ui-elements/es/icon/fill/Trash16';`",
    },
};
